import $ from 'jquery'

export default {
    name: 'import-excel-modal',
    components: {},
    props: {
        dispatch_action: String,
        emit_action: String,
        type_prestation: String,
		modal_toggler: Boolean
    },
    data() {
        return {
            files: [],
			is_loading: false,
			is_error: false
        }
    },

	watch: {
		modal_toggler() {
			this.files = []
			this.is_error = false
		}
	},

    computed: {

    },

    mounted() {

    },

    methods: {
        handleFilesUpload(event) {
			$('.err-msg').fadeOut()
			let uploadedFiles = this.$refs.files.files;

			console.log(event);
			console.log(typeof uploadedFiles);
			/*
			  Adds the uploaded file to the files array
			*/
			this.files = []
			for (var i = 0; i < uploadedFiles.length; i++) {
				this.files.push(uploadedFiles[i]);
			}
		},


		importFile() {
			this.is_loading = true

			let formData = new FormData();
			$('.err-msg').fadeOut()

			let err = 0

			if (this.files.length == 0) {
				err++
			}

			if (err == 0) {
				formData.append('file', this.files[0]);
				formData.append('type_prestation', this.dispatch_action);

				this.$store.dispatch('importPrestation', { 'data': formData }).then(() => {
					this.is_loading = false
					// après le rendu sur la page, faire disparaitre le modal
					this.files = []
					var preview = document.getElementById('upfile'+this.dispatch_action);
					preview.value = "";

					this.$refs.excel_modal.click()

					this.successToast("Importation effectuée avec succès");
					this.$emit(this.emit_action)
				}).catch(() => {
					this.is_error = true
					console.log("An error occured");
					this.is_loading = false
				})
			} else {
				// Afficher un message informant l'utilisateur de choisir un fichier
				$('.err-msg').fadeIn(500)
				this.is_loading = false
			}
		},
    }
}